/**
 * Convenience lookups for game kinds — all derived from the central
 * registry in `client/src/games/registry.tsx`. Adding a new game means
 * appending to the registry, not editing this file.
 */

import type { GameKind } from "../../../shared/protocol.js";
import { GAMES, type SeatBounds } from "../games/registry.js";

export const GAME_LABELS: Record<GameKind, string> = Object.fromEntries(
  GAMES.map((g) => [g.kind, g.label])
) as Record<GameKind, string>;

export const GAME_KINDS: readonly GameKind[] = GAMES.map((g) => g.kind);

export const GAME_TAGLINES: Record<GameKind, string> = Object.fromEntries(
  GAMES.map((g) => [g.kind, g.tagline])
) as Record<GameKind, string>;

export const GAME_BLURBS: Record<GameKind, string> = Object.fromEntries(
  GAMES.map((g) => [g.kind, g.blurb])
) as Record<GameKind, string>;

const SEAT_BOUNDS: Record<GameKind, SeatBounds> = Object.fromEntries(
  GAMES.map((g) => [g.kind, g.seatBounds])
) as Record<GameKind, SeatBounds>;

export function seatBoundsFor(kind: GameKind): SeatBounds {
  return SEAT_BOUNDS[kind];
}

/** All allowed seat counts for a given game, ascending. */
export function seatOptionsFor(kind: GameKind): number[] {
  const { min, max } = SEAT_BOUNDS[kind];
  const out: number[] = [];
  for (let n = min; n <= max; n++) out.push(n);
  return out;
}
